export default {
  getOption: (state) => (key) => state.options[key]
}
